export enum Encoding {
  Utf8 = "UTF-8",
  Utf16le = "UTF-16LE",
}
